import { create } from 'zustand'

interface Stats {
  total_processed: number
  total_duplicates: number
  total_errors: number
  uptime_secs: number
  total_connections: number
  watched_tokens: number
}

interface Latency {
  avg: number
  min: number
  max: number
}

interface StatsStore {
  stats: Stats
  latency: Latency | null
  solPrice: number | null
  setStats: (s: Stats) => void
  setLatency: (l: Latency) => void
  setSolPrice: (p: number) => void
}

export const useStatsStore = create<StatsStore>((set) => ({
  stats: {
    total_processed: 0,
    total_duplicates: 0,
    total_errors: 0,
    uptime_secs: 0,
    total_connections: 0,
    watched_tokens: 0,
  },
  latency: null,
  solPrice: null,
  setStats: (s: Stats) => set({ stats: s }),
  setLatency: (l: Latency) => set({ latency: l }),
  setSolPrice: (p: number) => set({ solPrice: p }),
}))
